import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function RecuperarContrasenaPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Por favor ingresa tu correo electrónico');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Por favor ingresa un correo electrónico válido');
      return;
    }

    setLoading(true);
    try {
      const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
      const res = await fetch(`${supabaseUrl}/functions/v1/send-reset-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Error al enviar el email. Intenta de nuevo.');
        return;
      }

      setEnviado(true);
    } catch {
      setError('Error de conexión. Por favor intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md">

          {enviado ? (
            <div className="bg-white rounded-lg border-2 border-green-200 p-10 text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-green-50 rounded-full mb-6">
                <i className="ri-mail-check-line text-4xl text-green-600"></i>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">
                ¡Email Enviado!
              </h2>
              <p className="text-gray-600 mb-2 text-base">
                Si <strong>{email}</strong> está registrado en IslaVende, recibirás un enlace para restablecer tu contraseña.
              </p>
              <p className="text-gray-500 text-sm mb-6">
                El enlace es válido por <strong>1 hora</strong>. Revisa también tu carpeta de Spam.
              </p>
              <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-sm text-amber-700 mb-6">
                <i className="ri-spam-line mr-2"></i>
                Si no ves el correo en 5 minutos, revisa tu carpeta de Spam o Correo No Deseado.
              </div>
              <Link
                to="/login"
                className="inline-block bg-gray-900 hover:bg-gray-800 text-white font-semibold py-3 px-8 rounded-lg transition-colors whitespace-nowrap"
              >
                Volver a Iniciar Sesión
              </Link>
            </div>
          ) : (
            <>
              <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-50 rounded-lg mb-4">
                  <i className="ri-lock-password-line text-3xl text-amber-600"></i>
                </div>
                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                  Recuperar Contraseña
                </h1>
                <p className="text-gray-600 text-sm">
                  Ingresa tu email y te enviaremos un enlace para crear una nueva contraseña
                </p>
              </div>

              <div className="bg-white rounded-lg border-2 border-gray-200 p-8">
                <form onSubmit={handleSubmit} className="space-y-5">
                  {error && (
                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm flex items-start gap-2">
                      <i className="ri-error-warning-line mt-0.5 shrink-0"></i>
                      <span>{error}</span>
                    </div>
                  )}

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      Correo Electrónico
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-900 focus:border-transparent outline-none transition-all"
                      placeholder="tu@email.com"
                      required
                      autoFocus
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-gray-900 hover:bg-gray-800 text-white font-semibold py-3 px-6 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                  >
                    {loading ? (
                      <span className="flex items-center justify-center gap-2">
                        <i className="ri-loader-4-line animate-spin"></i>
                        Enviando enlace...
                      </span>
                    ) : (
                      'Enviar Enlace de Recuperación'
                    )}
                  </button>
                </form>
              </div>

              <div className="mt-6 text-center space-y-2">
                <p className="text-gray-600 text-sm">
                  ¿Recordaste tu contraseña?{' '}
                  <Link to="/login" className="text-gray-900 hover:underline font-semibold">
                    Iniciar sesión
                  </Link>
                </p>
                <p className="text-gray-600 text-sm">
                  ¿No tienes cuenta?{' '}
                  <Link to="/registro" className="text-gray-900 hover:underline font-semibold">
                    Regístrate aquí
                  </Link>
                </p>
              </div>
            </>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}
